import { EmptyData } from '../../../core/models/empty-data';
import { CvDatabaseAccessTokenRequestActionDataModel } from '../models/cv-database-access-token-request-action-data';
import { UrlConfigContainer } from './../../../core/url-config';
import { AjaxDataServiceService } from './../../../core/ajax-data-service.service';
import { Observable } from 'rxjs';
import { CvDatabaseAccessTokenRequestModel } from '../models/cv-database-access-token-request-model';
import { PagingWrapper } from '../../../core/models/paging-wrapper';
import { CvDatabaseAccessTokenRequestFilterModel } from '../models/cv-database-access-token-request-filter-model';
import { PagingFilter } from '../../../shared/models/paging-filter.model';
import { Injectable } from '@angular/core';
import { UrlConfigService } from '@hrra/core';
import { CvDatabaseAccessTokenRequestAction } from '@admin/product-purchases/shared/models/cv-database-access-token-request-action';

@Injectable()
export class CvDatabaseProductService {
  public listCvDatabaseAccessTokenRequests(
    filter: PagingFilter<CvDatabaseAccessTokenRequestFilterModel>
  ): Observable<PagingWrapper<CvDatabaseAccessTokenRequestModel>> {
    return this.ajax.postDataPaging(
      this.urlService.urlConfig.api.data.productPurchases.cvdatabaseproduct.request.list,
      filter.toObject(),
      CvDatabaseAccessTokenRequestModel
    );
  }

  public approveCvDatabaseAccessTokenRequest(
    request: CvDatabaseAccessTokenRequestModel
  ) {
    let data = <CvDatabaseAccessTokenRequestActionDataModel>{
      action: CvDatabaseAccessTokenRequestAction.Approve,
      cvDatabaseAccessTokenRequestId: request.cvDatabaseAccessTokenRequestId,
    };

    var url = this.urlService.format(
      this.urlService.urlConfig.api.data.productPurchases.cvdatabaseproduct.request.process,
      { id: request.cvDatabaseAccessTokenRequestId }
    );
    return this.ajax.postData(url, data, EmptyData);
  }

  public rejectCvDatabaseAccessTokenRequest(
    request: CvDatabaseAccessTokenRequestModel
  ) {
    let data = <CvDatabaseAccessTokenRequestActionDataModel>{
      action: CvDatabaseAccessTokenRequestAction.Reject,
      cvDatabaseAccessTokenRequestId: request.cvDatabaseAccessTokenRequestId,
    };
    var url = this.urlService.format(
      this.urlService.urlConfig.api.data.productPurchases.cvdatabaseproduct.request.process,
      { id: request.cvDatabaseAccessTokenRequestId }
    );

    return this.ajax.postData(url, data, EmptyData);
  }

  public revokeCvDatabaseAccessTokenRequest(
    dbId: number,
    affectBilling: boolean
  ) {
    let data = <CvDatabaseAccessTokenRequestActionDataModel>{
      action: CvDatabaseAccessTokenRequestAction.Revoke,
      cvDatabaseAccessTokenRequestId: dbId,
      affectBilling: affectBilling,
    };
    var url = this.urlService.format(
      this.urlService.urlConfig.api.data.productPurchases.cvdatabaseproduct.request.process,
      { id: dbId }
    );

    return this.ajax.postData(url, data, EmptyData);
  }

  public approveCvDatabaseAccessTokenRequestWithModification(
    request: CvDatabaseAccessTokenRequestModel,
    newStoreItemId
  ) {
    let data = <CvDatabaseAccessTokenRequestActionDataModel>{
      action: CvDatabaseAccessTokenRequestAction.ApproveWithModification,
      cvDatabaseAccessTokenRequestId: request.cvDatabaseAccessTokenRequestId,
      newStoreItemIds: [newStoreItemId],
    };
    var url = this.urlService.format(
      this.urlService.urlConfig.api.data.productPurchases.cvdatabaseproduct.request.process,
      { id: request.cvDatabaseAccessTokenRequestId }
    );

    return this.ajax.postData(url, data, EmptyData);
  }

  constructor(
    private ajax: AjaxDataServiceService,
    private urlService: UrlConfigService<UrlConfigContainer>
  ) {}
}
